// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/multi-select/option/option.less
// module id = 3669
// module chunks = 0